import { Effect, Layer, Schema } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { DatabaseApi } from "../../api/database/service.ts";
import { makeDatabaseApi } from "../../api/database/live.ts";
import { DatabasePrompts } from "./prompts.ts";

export const DatabaseApiBrowserLive = Layer.effect(DatabaseApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeDatabaseApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const DatabasePromptsLive = Layer.succeed(DatabasePrompts, {
  ask: Effect.fn("Frontend.DatabasePrompts.ask")((message: string) => Effect.try({ try: () => window.prompt(message), catch: () => resourceUnavailable() }).pipe(Effect.flatMap(Schema.decodeUnknownEffect(Schema.NullOr(Schema.String))), Effect.mapError(() => resourceUnavailable())))
});
export const DatabaseBrowserPortsLive = Layer.merge(DatabaseApiBrowserLive, DatabasePromptsLive);
